import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocPortal, MapLocKeys } from '@cm/core/localization';

const dpRoot = `Candidate Access|Login|Employee Registration`;

const sharedProps = {
	feature: HubFeature.CandidateAccessLoginEmcEmployeeRegistration,
	portal: 'CP' as LocPortal,
};

type LocNameStart = 'CPEmployeeRegistrationForm';
export type CPEmployeeRegistrationLocs =
	| `${LocNameStart}FirstNameQuestionMark`
	| `${LocNameStart}LastNameQuestionMark`;

export const cpEmployeeRegistrationLocs: LocDefs<CPEmployeeRegistrationLocs> = {
	CPEmployeeRegistrationFormFirstNameQuestionMark: {
		defaultValue: 'First name must not contain only question marks',
		description: 'Error displayed when there are only question marks in the field',
		displayPath: `${dpRoot}|Field Error|First Name|Question Marks`,
		displayType: 'Error',
		...sharedProps,
	},
	CPEmployeeRegistrationFormLastNameQuestionMark: {
		defaultValue: 'Last name must not contain only question marks',
		description: 'Error displayed when there are only question marks in the field',
		displayPath: `${dpRoot}|Field Error|Last Name|Question Marks`,
		displayType: 'Error',
		...sharedProps,
	},
};

export const LOC_KEYS = MapLocKeys<CPEmployeeRegistrationLocs>(cpEmployeeRegistrationLocs);
